<template>
  <transition appear name="slow-fade" mode="out-in">
    <ProgressiveImage
      v-if="imageUrl"
      :key="imageUrl"
      class="comp"
      :src="imageUrl"
      :placeholder-src="imageThumb"
      :style="{ 'aspect-ratio': aspect }"
    />
    <div v-else-if="icon" :key="icon" class="icon-container comp">
      <svg-icon
        :icon="icon"
        :width="componentWidth"
        :height="componentHeight"
      />
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  props: {
    id: {
      type: String,
      default: null,
    },
    componentWidth: {
      type: String,
      default: '70%',
    },
    componentHeight: {
      type: String,
      default: '70%',
    },
    defaultAspect: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      aspect: 1,
    };
  },

  computed: {
    ...mapGetters('project/data/components', [
      'getCoverId',
      'getCoverIcon',
      'getDefaultIcon',
    ]),
    ...mapGetters('project/data/assets', [
      'getFullImageUrl',
      'getTinyImageUrl',
    ]),

    /**
     * Return the cover asset id for this component
     * @returns {String}
     */
    coverId() {
      return this.getCoverId(this.id);
    },

    /**
     * Return the icon of the cover asset (or the default icon)
     * @return {String|null}
     */
    icon() {
      return this.getCoverIcon(this.id) || this.getDefaultIcon;
    },

    /**
     * Return the full image url for the cover asset
     * @returns {String}
     */
    imageUrl() {
      return this.getFullImageUrl(this.coverId);
    },

    /**
     * Return the tiny image url for the cover asset
     * @returns {String}
     */
    imageThumb() {
      return this.getTinyImageUrl(this.coverId);
    },
  },

  watch: {
    defaultAspect(newValue) {
      if (newValue && this.imageUrl) {
        const img = new Image();

        img.onload = () => {
          this.aspect = img.width / img.height;
          console.log(`the image dimensions are ${img.width}x${img.height}`);
          console.log(`the image aspect ration is ${img.width / img.height}`);
        };

        img.src = this.imageUrl;
      } else {
        this.aspect = 1;
      }
    },
  },

  /**
   * Vue created lifecycle hook.
   */
  created() {
    if (this.imageUrl && this.defaultAspect) {
      const img = new Image();

      img.onload = () => {
        this.aspect = img.width / img.height;
        console.log(`the image dimensions are ${img.width}x${img.height}`);
        console.log(`the image aspect ration is ${img.width / img.height}`);
      };

      img.src = this.imageUrl;
    }
  },
};
</script>
<style scoped lang="scss">
.icon-container {
  align-items: center;
  justify-content: center;
}
img.comp {
  max-height: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  margin: 10px;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.comp :deep(img) {
  object-fit: cover;
  width: 100%;
  height: 100%;
  user-select: none;
}

// @media (max-width: 740px) {
//   img {
//     max-height: 300px;
//   }
// }
// }
</style>
